export const bluesky = () => (
  <path
    d="M5.769 3.423C8.29 5.317 11.004 9.156 12 11.217c.996-2.06 3.709-5.9 6.231-7.794C20.051 2.057 23 1 23 4.363c0 .673-.385 5.645-.611 6.452-.785 2.806-3.647 3.522-6.192 3.089 4.449.757 5.58 3.265 3.137 5.773-4.643 4.764-6.673-1.195-7.193-2.722-.096-.28-.14-.41-.141-.3 0-.11-.045.02-.14.3-.52 1.527-2.55 7.486-7.193 2.722-2.445-2.508-1.313-5.016 3.136-5.773-2.545.433-5.407-.283-6.192-3.09C1.385 10.009 1 5.037 1 4.365 1 1 3.949 2.057 5.769 3.424"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
